import React, { useCallback, useState } from 'react'
import { Body, Button, Input, Modal, Spacer, useToasts } from '@vestaboard/installables'
import { useCreateDealAssociation } from '../hooks/useCreateDealAssociation'

interface ICreateDealAssociationModalProps {
  visible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateDealAssociationModal = (props: ICreateDealAssociationModalProps) => {
  const [emailAddress, setEmailAddress] = useState('')
  const [dealId, setDealId] = useState('')
  const [createDealAssociationMutation] = useCreateDealAssociation()
  const { addToast } = useToasts()
  const [error, setError] = useState<string | null>(null)

  const createDealAssociation = useCallback(async () => {
    if (!emailAddress) {
      setError('email')
      return
    }

    if (!dealId) {
      setError('dealId')
      return
    }

    const result = await createDealAssociationMutation({
      variables: {
        input: {
          emailAddress,
          dealId
        }
      }
    })

    if (result.data?.createDealAssociation?.__typename === 'DealAssociationV2') {
      addToast('Deal association created successfully', { appearance: 'success', autoDismiss: true })
      props.onSuccess()
    } else {
      addToast('Failed to create deal association', { appearance: 'error', autoDismiss: true })
      props.onClose()
    }
  }, [emailAddress, dealId, createDealAssociationMutation, addToast, props])

  return (
    <Modal visible={props.visible} onClose={props.onClose} transparent>
      <div>
        <Body>Deal ID</Body>
        <Input value={dealId} onValueChange={setDealId} error={error === 'dealId' ? 'Required' : undefined} />
        <Spacer size='medium' />
        <Body>Email Address</Body>
        <Input
          value={emailAddress}
          onValueChange={setEmailAddress}
          error={error === 'email' ? 'Required' : undefined}
        />
        <Spacer size='large' />
        <Button buttonType='white' onClick={createDealAssociation}>
          Create Deal Association
        </Button>
      </div>
    </Modal>
  )
}
